import { Component, OnInit, Input } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
/*App imports*/
import { HelpersService, TiposCalculos } from '../../../../../services/tools/helpers.service';


@Component({
    selector: 'app-plazo-item',
    templateUrl: './plazo-item.component.html',
    styleUrls: ['./plazo-item.component.scss'],
  })

export class PlazoItemComponent implements OnInit {
    @Input() public plazo_periodo: number = null;
    @Input() public plazo_medida: string = null;

    public errors:any = {};

    public plazoSelected: string = null;
    public creditoMaximo: number = 0;
    public customValue: number = null;

    constructor(
    ){
    }

    public ngOnInit() {
    }

    public onCustomSieteMesesChange(plazo: string){
        console.log('plazo_medida', this.plazo_medida);
        console.log('plazo_periodo', this.plazo_periodo);
        this.plazoSelected = plazo;
    }
}


// WEBPACK FOOTER //
// ./src/app/creditos/nomina/simulador/components/plazo-item/plazo-item.component.ts